// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"28860c89","977":"c2e63d56"}[chunkId] + ".chunk.js";
};